// extracted by mini-css-extract-plugin
var _1 = "ShortcutRow-module__shortcut--TPrRc";
var _2 = "ShortcutRow-module__shortcutName--piCow";
export { _1 as "shortcut", _2 as "shortcutName" }
